import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import invariant from 'tiny-invariant';

import { useWorkflowStackSiderView } from '../../../../hooks/stack-sider-view';
import { StageForm } from './StageForm';
import { StageList } from './StageList';

export const StageContent: FC = () => {
  const { t } = useTranslation();
  const stackSiderView = useWorkflowStackSiderView();

  const siderConfig = stackSiderView.lastItem?.config;

  invariant(
    siderConfig?.viewType === 'workflow-details',
    t('unreachable-code'),
  );

  switch (siderConfig.stageViewType) {
    case 'list':
      return <StageList />;
    case 'new-stages-form':
      return <StageForm type="new" />;
    case 'edit-stages-form':
      return <StageForm type="edit" />;
    default:
      return null;
  }
};
